var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11111 9.23328H1.90278L7.33333 4.01995L6.54166 3.25995L1.11111 8.47328V9.23328ZM0 10.2999V8.03328L7.33333 1.00662C7.44444 0.90884 7.56722 0.833284 7.70166 0.779951C7.83611 0.726618 7.97722 0.699951 8.125 0.699951C8.27277 0.699951 8.41629 0.726618 8.55555 0.779951C8.69481 0.833284 8.81518 0.913284 8.91666 1.01995L9.68055 1.76662C9.79166 1.8644 9.87277 1.97995 9.92389 2.11328C9.975 2.24662 10.0004 2.37995 10 2.51328C10 2.65551 9.97463 2.79115 9.92389 2.92022C9.87315 3.04928 9.79203 3.16697 9.68055 3.27328L2.36111 10.2999H0ZM6.93055 3.64662L6.54166 3.25995L7.33333 4.01995L6.93055 3.64662Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.cab1806e20c686f01c489a0b71bf759f.svg";
export { ForwardRef as ReactComponent };